import { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import queryString from 'query-string'
import * as routes from '../routes'
import { Loading, withRouter, useTitle } from '../shared'
import { AlertContext, Button } from '../widgets'
import PublicUserLink from './PublicUserLink'
import AppStoreBanner from './AppStoreBanner'

const PublicPresetView = (props) => {
  const [loading, setLoading] = useState(true)
  const [preset, setPreset] = useState(null)

  const { handleError } = useContext(AlertContext)

  useEffect(() => {
    load()
  }, [])

  useTitle(preset ? `${preset.name} by ${preset.username}` : null)

  const getId = () => queryString.parse(props.router.location.search).id

  const load = () => {
    setLoading(true)
    axios.get(
      routes.dynamic(routes.presetUrl, getId())
    ).then((response) => {
      setPreset(response.data)
    }).catch((error) => {
      handleError(error)
    }).finally(() => {
      setLoading(false)
    })
  }

  if (loading) {
    return <Loading />
  }

  return <>
    <AppStoreBanner />

    {preset && <>
      <div className='public-view-background'>
        <img src={preset.images['400']} alt='' />
      </div>

      <div className='public-view-body'>
        <img className='public-view-artwork' src={preset.images['400']} alt='' />
        <div className='public-view-item-title'>{preset.name}</div>

        <PublicUserLink user_id={preset.user_id} username={preset.username} />

        {preset.description && <div className='public-view-description'>{preset.description}</div>}

        <a className='public-view-open-in-app' href={routes.dynamic(routes.singularAppLink, encodeURIComponent(routes.dynamic(routes.volocoPresetLink, preset.id)))} target='_blank' rel='noreferrer noopener'>
          <Button className='medium'>Open in Voloco</Button>
        </a>
      </div>
    </>}
  </>
}

export default withRouter(PublicPresetView)
